import styled from 'styled-components';
import QR from 'assets/img/qr-download.png';

 const QRDownload = styled.img`
  ${props => props}
  width: ${props => props.size || '140px'};
  height: ${props => props.size || '140px'};
  max-width: 320px;
  max-height: 320px;
  border-radius: ${props => props.theme.old.rounded[props.rounded] || props.theme.old.rounded.xs};
`;

QRDownload.defaultProps = {
  src: QR,
  alt: "QR Download Flixxo"
}

export default QRDownload